import { render, staticRenderFns } from "./custom-links-edit-tab.vue?vue&type=template&id=2fddc0fd&scoped=true"
import script from "./custom-links-edit-tab.vue?vue&type=script&lang=js"
export * from "./custom-links-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./custom-links-edit-tab.vue?vue&type=style&index=0&id=2fddc0fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fddc0fd",
  null
  
)

export default component.exports